import React, { createContext, useContext, useState } from 'react';

const TabsContext = createContext();

const Tabs = ({
  children,
  defaultValue,
  value,
  onChange,
  className = '',
}) => {
  const [internalValue, setInternalValue] = useState(defaultValue);
  const currentValue = value !== undefined ? value : internalValue;

  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue);
    } else {
      setInternalValue(newValue);
    }
  };

  return (
    <TabsContext.Provider value={{ value: currentValue, onChange: handleChange }}>
      <div className={className}>
        {children}
      </div>
    </TabsContext.Provider>
  );
};

const TabsList = ({ children, className = '' }) => {
  return (
    <div className={`flex border-b border-stroke dark:border-strokedark ${className}`}>
      {children}
    </div>
  );
};

const TabsTrigger = ({ value, children, className = '', disabled = false }) => {
  const context = useContext(TabsContext);
  const isActive = context.value === value;

  return (
    <button
      type="button"
      onClick={() => !disabled && context.onChange(value)}
      disabled={disabled}
      className={`
        px-4 py-3 text-sm font-medium border-b-2 -mb-px transition-colors
        ${isActive
          ? 'border-brand-500 text-brand-500'
          : 'border-transparent text-body hover:text-black dark:text-bodydark dark:hover:text-white'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
    >
      {children}
    </button>
  );
};

const TabsContent = ({ value, children, className = '' }) => {
  const context = useContext(TabsContext);

  if (context.value !== value) {
    return null;
  }

  return (
    <div className={`pt-4 ${className}`}>
      {children}
    </div>
  );
};

Tabs.List = TabsList;
Tabs.Trigger = TabsTrigger;
Tabs.Content = TabsContent;

export { Tabs, TabsList, TabsTrigger, TabsContent };
export default Tabs;
